<div class="brand">
  <a
    class="brand__link"
    routerLink="/home"
    aria-label="Community Resource Directory home"
    (click)="handleBrandNavigation()">
    <span class="brand__mark" aria-hidden="true">
      <img src="assets/images/cosd-logo.png" alt="">
    </span>
    <span class="brand__copy">
      <span class="brand__eyebrow">County Of San Diego Probation</span>
      <h1 class="brand__title brand__title--desktop">Community Resource Directory</h1>
      <h1 class="brand__title brand__title--mobile">Community Resource Directory</h1>
      <span class="brand__subtitle">Provider accounts, reporting, and referral management in one place.</span>
    </span>
  </a>

  <div class="brand__actions">
    <button
      type="button"
      class="brand__menu-toggle"
      (click)="toggleMobileMenu()"
      aria-label="Toggle navigation menu"
      aria-haspopup="dialog"
      aria-controls="mobileNavigation"
      [attr.aria-expanded]="isMobileMenuOpen">
      <fa-icon [icon]="isMobileMenuOpen ? faXmark : faBars"></fa-icon>
    </button>
  </div>
</div>
